import { v4 as uuid } from 'uuid'
import { ACTIONS } from './constants'

const state = {
  aggregator: null,
  isLocalhost: false,
  isProduction: false,
  checkoutId: '',
  locale: 'en_US',
  srciActionCode: ACTIONS.INIT,
  unbindError: false,
  srciDidHandleEnrollmentError: false,
  traceId: uuid()
}

export default state
